import { Spinner } from "react-bootstrap";
export const Loader = () => {
  return (
    <div className="text-center mt-5">
      <Spinner variant="primary" animation="grow" />
    </div>
  );
};
